import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Profiling Docker Images`}</h2>
    <p>{`As it happens in the middle of a frantic week of prototyping a nodejs app, I installed a bunch of dependencies and was ready to deploy my app to the cloud. At which point I noticed that the docker build step was taking forever.
I ran `}<inlineCode parentName="p">{`docker image ls`}</inlineCode>{` and saw that my image was 4 GBs in size. Although I wanted to blame it on the random libraries I had installed, the huge size made me think it was a mistake in my .gitignore file and maybe I was adding some images or something into my docker images.`}</p>
    <p>{`I was saved by `}<a parentName="p" {...{
        "href": "https://github.com/wagoodman/dive"
      }}>{`dive`}</a>{`.`}</p>
    <p>{`Find the ID of the offending docker image.`}</p>
    <deckgo-highlight-code {...{
      "language": "shell",
      "terminal": "carbon"
    }}>{`
          `}<code parentName="deckgo-highlight-code" {...{
        "slot": "code"
      }}>{`docker image ls`}</code>{`
        `}</deckgo-highlight-code>
    <deckgo-highlight-code {...{
      "language": "shell",
      "terminal": "carbon"
    }}>{`
          `}<code parentName="deckgo-highlight-code" {...{
        "slot": "code"
      }}>{`dive IMAGE_ID`}</code>{`
        `}</deckgo-highlight-code>
    <p>{`This brings up a tree view of all the files within the various layers of your image.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/177a87f2d7ae0fcc67c0d41424c92dab/29114/dive-screenshot.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.333333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4ElEQVQoz12PW4+aUBRGSTM6KireAMELcDggAp4bB1BuTr1mps3YhybtUx/7/39CozPtdCZZ+bKTb6/sbGHP0NksdvO4HJNKo4WCs9Eqk9F1kMNnUl7w5wvdfufHr6iIux6qm7gBUM3gg1D4sf/y+/HXz+xSTXmukmQQxD0/7vu85/P+spijakYrG+/cZOuhSPJo26Edh7TsVCXCEZY7M60mUamzSo9e4NKStG5LfROJFhmYibyINIOINmlB0oK4ARIZCweYlxrlkkdFh7Zd9j9dh41sJsFIBmvV5xNAJfBOPjrF2SkepnHS93nXe+muNCFtw0iGrAu5AtdqsJl5tH2rxL8y63rbCf+GT3sz/SCzjptpK95bZHpYTkimh1R03l1mkldq9Hm1z1X8ZrYgbtpc8nZGmvSDUmcHkFHRwU37o7wZrZ6WD5mCWdu5fn4Dt2DcW+6MNB2GlR4drE3UWfxrSdNOFSKE91ZYN1EDhHXTv5sHNSOoGWHdDO9NIsJ8TFjXzVRUaPRa3b3if5rRni8cQX6ysvMtTyA/gexs53tjnQ9JpUZnkJcyy4d0q/FHp3wDFk/BQcCIu2ABZsCagdecA0M3FEnV5rq1sMa6pkxUfaojd4lDgnyMfERXdOWhP/XMZp1uxZQcAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Screenshot of Dive",
            "title": "Screenshot of Dive",
            "src": "/static/177a87f2d7ae0fcc67c0d41424c92dab/c1b63/dive-screenshot.png",
            "srcSet": ["/static/177a87f2d7ae0fcc67c0d41424c92dab/5a46d/dive-screenshot.png 300w", "/static/177a87f2d7ae0fcc67c0d41424c92dab/0a47e/dive-screenshot.png 600w", "/static/177a87f2d7ae0fcc67c0d41424c92dab/c1b63/dive-screenshot.png 1200w", "/static/177a87f2d7ae0fcc67c0d41424c92dab/d61c2/dive-screenshot.png 1800w", "/static/177a87f2d7ae0fcc67c0d41424c92dab/29114/dive-screenshot.png 1920w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Thankfully it was a `}<inlineCode parentName="p">{`.parcel-cache`}</inlineCode>{` that snuck into the image. Adding it to .dockerignore brought down the image size from 4 GB to 814 MB. This big drop made me write this.`}</p>
    <p>{`Cherry on top : I realized that there's a `}<inlineCode parentName="p">{`--production`}</inlineCode>{` flag for npm install that removes devDependencies. This brought the size down to 358 MB.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      